import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalResponseCodes } from '@src/suite/common/components/modal/modal.service';

export interface ModalData {
    title: string;
    content: any;
    yes: string;
    no: string;
}

@Component({
    selector: 'st-modal',
    templateUrl: './modal.html',
    styleUrls: ['./modal.scss'],
    host: {
        class: 'st-modal',
    },
    encapsulation: ViewEncapsulation.None,
})
export class ModalComponent {
    @Input() public title: string = 'Title';
    @Input() public content: any = 'Content';

    @Input() public yes: string = 'Yes';
    @Input() public no: string = 'No';

    constructor(
        public dialogRef: MatDialogRef<ModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ModalData,
        private domSanitizer: DomSanitizer
    ) {
        this.title = data.title;
        this.content = data.content;
        this.yes = data.yes;
        this.no = data.no;
    }

    onNoClick(): void {
        this.dialogRef.close(ModalResponseCodes.CANCEL);
    }

    onYesClick(): void {
        this.dialogRef.close(ModalResponseCodes.OK);
    }
}
